import FJConstant from '../../constants/FJConstant.js';
import FJTextToSpeechStore from '../../store/FJTextToSpeechStore.js';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import FJTextToSpeechConfig from '../../config/appConfig/FJTextToSpeechConfig.js';
import FJS3NetworkManager from '../../store/FJS3NetworkManager.js';
import { setSliceProjectList } from '../slices/FJSliceTextToSpeech.js';
import { setSliceSelectListAction } from '../slices/FJSliceCommon.js';
import FJUtil from '../../util/FJUtil.js';
import FJActionCommon from './FJActionCommon.js';
import FJMessageStore from '../../store/FJMessageStore.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import { setSliceIsShowTTVProjectModal, setSliceTTVProjectInfo } from '../slices/FJSliceTextToSpeech.js';
import FJS3Config from '../../config/FJS3Config.js';
import FJActionTextToSpeech from './FJActionTextToSpeech.js';
import { setSliceAddAsEditPageModalBtuStatus } from '../slices/FJSliceModals.js';
import FJActionModal from './FJActionModal.js';
import FJConfig from '../../config/FJConfig.js';

let f_recordSpeechList = [];

const FJActionTextToSpeechProject = {
    setSliceProjectListAction: function (projectList) {
        return dispatch => {
            dispatch(setSliceProjectList(projectList));
        };
    },

    recordSaveSpeechListAction: function (selectIdList) {
        return (dispatch, getState) => {
            const state = getState();
            const { currentSpeechList } = state.textToSpeech;

            f_recordSpeechList = currentSpeechList.filter(item => {
                return item.status === FJConstant.SUCCESS || selectIdList.indexOf(item.id) !== -1;
            });
        };
    },

    /**
     * @description 保存TTV工程
     */
    save: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const { currentSpeechList } = state.textToSpeech;
            const successDataList = currentSpeechList.filter(item => item.status === FJConstant.SUCCESS);

            // 都没有生成不需要保存
            if (successDataList.length === 0) {
                return;
            }

            const _createError = () => {
                console.log('创建失败');
            };

            if (!FJTextToSpeechStore.getPid()) {
                // 先调用创建工程接口
                const { code, data } = await FJNetworkStore.createTTVProject({
                    text: successDataList[0].text,
                });
                if (code === 200) {
                    FJTextToSpeechStore.setPid(data.project_id);
                } else {
                    // 创建失败
                    _createError();
                    return;
                }
            } else {
                const uploadText = FJTextToSpeechStore.getUploadText();
                if (uploadText !== successDataList[0].text) {
                    // 如果上传的文本和当前的文本不一致，则需要更新上传的文本
                    const { code, data } = await FJNetworkStore.createTTVProject({
                        text: successDataList[0].text,
                        projectId: FJTextToSpeechStore.getPid(),
                    });
                    if (code === 200) {
                        FJTextToSpeechStore.setPid(data.project_id);
                    } else {
                        _createError();
                        // 创建失败
                        return;
                    }
                }
            }

            const pid = FJTextToSpeechStore.getPid();
            const uploadDataList = successDataList.map(item => {
                return {
                    voiceInfo: item.voiceInfo,
                    generationType: item.generationType,
                    audioUrl: item.audioUrl,
                    audioDuration: item.audioDuration,
                    text: item.text,
                    id: item.id,
                };
            });
            const jsonBlob = new Blob([JSON.stringify(uploadDataList)], {
                type: 'application/octet-stream"',
                name: 'info.json',
            });

            const s3Key = `${FJTextToSpeechConfig.ttvProjectKey}${pid}/info.json`;
            FJS3NetworkManager.uploadToS3(jsonBlob, s3Key, response => {
                switch (response.type) {
                    case 'progress':
                        break;
                    case 'done':
                        // 保存成功
                        break;
                    case 'error':
                        // 保存失败
                        _createError();
                        break;
                    default:
                }
            });
            dispatch(this.getProjectList());
        };
    },

    deleteProjectAction: function (ids) {
        return async dispatch => {
            try {
                const result = await FJNetworkStore.deleteTTVProject(ids);
                const { code } = result;
                if (code === 200) {
                    dispatch(setSliceSelectListAction([]));
                    dispatch(this.getProjectList());
                    dispatch(FJActionCommon.setIsMultipleModeAction(false));
                } else if (code === 214) {
                    FJUtil.login();
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-delete-please-try-again'), 'error');
                }
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-delete-please-try-again'), 'error');
            }
        };
    },

    /**
     * @description 获取TTV工程列表
     */
    getProjectList: function () {
        return async dispatch => {
            const { code, data } = await FJNetworkStore.getTTVProjectList();
            if (code === 200) {
                dispatch(this.setSliceProjectListAction(data.list));
            } else {
                // console.log('获取TTV工程列表失败');
            }
        };
    },

    setSliceIsShowTTVProjectModalAction: function (isShow) {
        return dispatch => {
            dispatch(setSliceIsShowTTVProjectModal(isShow));
        };
    },

    openTTVProjectModalAction: function (pid) {
        return async (dispatch, getState) => {
            try {
                const state = getState();
                const { projectList } = state.textToSpeech;
                const createTime = projectList.find(item => item.pid === pid).created_at;
                const jsonPath = `${FJS3Config.S3_NOT_CATCH_HOST}${FJTextToSpeechConfig.ttvProjectKey}${pid}/info.json`;
                const list = await FJNetworkStore.getDataByJson(jsonPath);

                dispatch(this.setSliceIsShowTTVProjectModalAction(true));
                dispatch(setSliceTTVProjectInfo({ list: list, createTime: createTime, pid: pid }));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
            }
        };
    },

    closeTTVProjectModalAction: function () {
        return dispatch => {
            dispatch(this.setSliceIsShowTTVProjectModalAction(false));
        };
    },

    onEditAction: function (pid, options = {}) {
        return async dispatch => {
            dispatch(
                FJActionModal.showWarningModalAction({
                    title: FJLocalStore._('the-content-being-edited-will-be-replaced'),
                    content: FJLocalStore._(
                        'editing-history-will-replace-the-content-you-are-currently-editing-the-current-content-may-be-lost-are-you-sure-to-continue',
                    ),
                    footerDates: [
                        {
                            btnType: FJConstant.WARNING,
                            btnText: FJLocalStore._('continue'),
                            btnCallback: async () => {
                                dispatch(FJActionTextToSpeechProject.closeTTVProjectModalAction());

                                const { list = [] } = options;
                                let useList = list;
                                if (list.length === 0) {
                                    const jsonPath = `${FJS3Config.S3_NOT_CATCH_HOST}${FJTextToSpeechConfig.ttvProjectKey}${pid}/info.json`;
                                    useList = await FJNetworkStore.getDataByJson(jsonPath);
                                }
                                FJTextToSpeechStore.setPid(pid);
                                const speechList = useList.map(item => {
                                    return {
                                        ...item,
                                        status: FJConstant.SUCCESS,
                                        generateInfo: {
                                            text: item.text,
                                            voiceInfo: item.voiceInfo,
                                            generationType: item.generationType,
                                        },
                                    };
                                });

                                dispatch(FJActionTextToSpeech.setSliceCurrentSpeechListAction(speechList));
                                dispatch(FJActionTextToSpeech.setSliceSpeechSelectIdAction(speechList[0].id));
                                dispatch(FJActionTextToSpeech.updateVoiceInfoAction());
                                dispatch(FJActionTextToSpeech.changeTabIndexAction(0));
                            },
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: null,
                        },
                    ],
                }),
            );
        };
    },

    onDownloadByPidAction: function (pid) {
        return async dispatch => {
            try {
                const jsonPath = `${FJS3Config.S3_NOT_CATCH_HOST}${FJTextToSpeechConfig.ttvProjectKey}${pid}/info.json`;
                const list = await FJNetworkStore.getDataByJson(jsonPath);
                dispatch(
                    FJActionTextToSpeech.multiDownloadAction(
                        list.map(item => {
                            let audioUrl = item.audioUrl;
                            switch (item.generationType) {
                                case FJConstant.MICROSOFT:
                                    audioUrl = FJS3Config.S3_SERVER_HOST + item.audioUrl;
                                    break;
                                case FJConstant.CLONE_BY_SELF:
                                case FJConstant.CLONE_BY_FLEX_CLIP:
                                    audioUrl = FJS3Config.S3_SERVER_HOST + FJConfig.resultAudioKey + item.audioUrl;
                                    break;
                                default:
                            }
                            return audioUrl;
                        }),
                    ),
                );
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-download-please-try-again'), 'error');
            }
        };
    },

    onUseToFlexClipAction: function (speechList) {
        return async dispatch => {
            dispatch(setSliceAddAsEditPageModalBtuStatus(FJConstant.LOADING));
            const _getAudioUrl = item => {
                switch (item.generationType) {
                    case FJConstant.MICROSOFT:
                        return FJS3Config.S3_SERVER_HOST + item.audioUrl;
                    default:
                        return FJS3Config.S3_SERVER_HOST + FJConfig.resultAudioKey + item.audioUrl;
                }
            };

            const _getAudioType = item => {
                switch (item.generationType) {
                    case FJConstant.MICROSOFT:
                        return 'audio/mpeg';
                    default:
                        return 'audio/wav';
                }
            };

            let blobList = [];
            try {
                blobList = await Promise.all(
                    speechList.map(async item => {
                        const blob = await FJUtil.downloadVideoCacheAvoidance(_getAudioUrl(item));
                        if (!blob) throw new Error('network error');
                        return blob;
                    }),
                );
                if (blobList.length === 0) throw new Error('network error');
                blobList = blobList.map((blob, index) => new Blob([blob], { type: _getAudioType(speechList[index]) }));
                blobList.forEach(blob => {
                    blob.name = FJUtil.getUseFileName('', '.mp3');
                });
                FJUtil.eaLog('ai tool make video click', { tool: 'text_to_speech' });
                const _jumpUrl = uploadKey => {
                    dispatch(FJActionTextToSpeech.setSliceDownloadStatusAction(FJConstant.DEFAULT));
                    dispatch(FJActionModal.hideGenerateLoadingModalAction());

                    const url = FJUtil.getCurrentUrl() + 'editor/app?rec_id=' + uploadKey;
                    window.open(url);
                };
                FJUtil.readFiles(
                    blobList,
                    {
                        module: 'media',
                        applyTimeline: true,
                        isAdaptDuration: true,
                    },
                    _jumpUrl,
                );
            } catch (e) {
                console.error(e);
                dispatch(FJActionTextToSpeech.setSliceDownloadStatusAction(FJConstant.DEFAULT));
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
            } finally {
                dispatch(setSliceAddAsEditPageModalBtuStatus(FJConstant.SUCCESS));
            }
        };
    },
};

export default FJActionTextToSpeechProject;
